export const DISPATCH_TYPES_OPTIONS = ['tickets', 'contacts', 'messages', 'eventtrackings', 'monitorings'];
export const WEBHOOK_ADVANCED_SETTINGS = 'Webhook.AdvancedSettings';
export const WEBHOOK_OAUTH_ENABLED = 'Webhook.OAuthEnabled';
export const WEBHOOK_URL = 'Webhook.Url';
export const AUTHORIZATION = 'Authorization';
